<template>
  <detail-layout-full-width>
    <template slot="header">
      <base-header
        icon="user"
        :content="header"
      />
    </template>
    <template slot="main">
      <div class="form-wrapper">
        <el-form
          :model="form"
          :rules="rules"
          ref="ruleForm"
          autocomplete="off"
        >
          <div class="lg:max-w-detail lg:mr-auto">
            <div class="lg:mb-4">
            </div>
            <div class="lg:mb-2" v-if="role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador'">
              <div class="flex justify-between items-center">
                <div class="flex-1">
                  <AccessibleElSelect
                    v-model="form.clienteId"
                    prop="clienteId"
                    :options="clientesForAccessibleSelect"
                    clearable
                    :isDisabled="!isCreate"
                    id-prefix="group"
                  >
                    <template slot="label">
                      <base-obligatory-icon v-if="isCreate"/>
                      {{$t('app.client')}}
                    </template>
                  </AccessibleElSelect>
                </div>
                <base-button
                  v-if="!isCreate"
                  class="ml-4"
                  mode="primary"
                  :text="$t('app.detail')"
                  @click.prevent.stop="goDetailClient"
                  :loading="isGeneralLoading"
                />
              </div>
            </div>
            <div class="lg:mb-2">
              <div class="mandatory">
                <span id="group-name-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('configurations.name')}}</span>
                  <el-form-item prop="name">
                    <el-input
                      :disabled="form.tipo === 1"
                      aria-labelledby="group-name-label"
                      class="w-full"
                      v-model="form.name"
                      maxlength='50'
                      >
                        <template v-if="form.name && form.tipo !== 1" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de nombre"
                            @clear="form.name = ''"
                          />
                        </template>
                    </el-input>
                  </el-form-item>
              </div>
            </div>
            <div class="lg:mb-2">
              <AccessibleElSelect
                v-model="form.tipo"
                prop="tipo"
                :options="tiposGrupoFilteredForAccessibleSelect"
                clearable
                :isDisabled="!isCreate"
                id-prefix="group"
              >
                <template slot="label">
                  <div class="flex items-center">
                    <span>
                      <base-obligatory-icon v-if="isCreate"/>
                      {{$t('configurations.group_type')}}
                    </span>
                    <base-tooltip-icon :formatContent="true" size="sm" :content="tooltipTipoGrupo" class="ml-2"/>
                  </div>
                </template>
              </AccessibleElSelect>
            </div>

            <!-- <div class="lg:mb-2" v-if="form.tipo == 2 || form.tipo === 3">
              <div class="mandatory">
                <div class="flex flex-row items-center  mb-1">
                  <label class="text-sm font-semibold text-secondary-600 block"><base-obligatory-icon v-if="form.tipo === 3"/>{{$t('configurations.emails')}}</label>
                  <base-tooltip-icon size="sm" :content="contentTooltipEmail" class="ml-2"/>
                </div>
                <el-form-item prop="email">
                  <el-input
                    :disabled="form.tipo === 1"
                    clearable
                    class="w-full"
                    v-model="form.email"
                    maxlength='255'
                  />
                </el-form-item>
              </div>
            </div> -->

            <div class="mb-6">
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{$t('groups.desc')}}
                <el-form-item prop="Descripcion">
                  <el-input
                    type="textarea"
                    :rows="3"
                    class="w-full"
                    :aria-label="$t('groups.desc')"
                    v-model="form.Descripcion"
                    maxlength="4000"
                  />
                </el-form-item>
              </label>
            </div>


            <div class="mb-6">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="switch-ver-todo-groups" class="sr-only">
                    {{$t('configurations.ver_todo_groups')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-groups"
                    :aria-label="$t('configurations.ver_todo_groups')"
                    class="switch-text break-normal" 
                    :disabled="form.tipo === 3 || form.tipo === 1 || !hasPermissionEditVisiblity" 
                    v-model="form.verTodoGroups" 
                    :active-text="$t('configurations.ver_todo_groups')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipverTodoGroups" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="switch-ver-todo-statuses" class="sr-only">
                    {{$t('configurations.ver_todo_statuses')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-statuses"
                    :aria-label="$t('configurations.ver_todo_statuses')"
                    class="switch-text break-normal" 
                    :disabled="form.tipo === 3 || (form.tipo === 1 && !availableUpdateVerTodoStatuses) || !hasPermissionEditVisiblity" 
                    v-model="form.verTodoStatuses" 
                    :active-text="$t('configurations.ver_todo_statuses')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoStatuses" class="ml-1"/>
                </div>
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="switch-ver-todo-companies" class="sr-only">
                    {{$t('configurations.ver_todo_companies')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-companies"
                    :aria-label="$t('configurations.ver_todo_companies')"
                    class="switch-text break-normal" 
                    :disabled="form.tipo === 3 || (form.tipo === 1 && !availableUpdateVerTodoCompanies) || !hasPermissionEditVisiblity" 
                    v-model="form.verTodoCompanies" 
                    :active-text="$t('configurations.ver_todo_companies')"></el-switch>
                  <base-tooltip-icon size="sm" :content="tooltipVerTodoCompanies" class="ml-1"/>
                </div>
              </div>
            </div>

            <div class="mb-6" v-if="hasModulePermisosGruposTraspasoNEOs">
              <div class="flex flex-col lg:flex-row lg:space-x-4">
                <div class="flex flex-row items-center mb-4 lg:mb-0">
                  <label for="switch-ver-todo-asignar-grupos" class="sr-only">
                    {{$t('configurations.ver_todo_groups_asign')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-ver-todo-asignar-grupos"
                    :aria-label="$t('configurations.ver_todo_groups_asign')"
                    class="switch-text break-normal" 
                    :disabled="form.tipo === 3 || form.tipo === 1"
                    v-model="form.verTodoAsignarGrupos" 
                    :active-text="$t('configurations.ver_todo_groups_asign')"/>
                  <!-- <base-tooltip-icon size="sm" :content="tooltipverTodoAsignarGrupos" class="ml-1"/> -->
                </div>
              </div>
            </div>
          <base-collapsible-form 
            ref="baseCollapsibleAlerts" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <h2 class="dark:text-darkblue-200 font-bold mt-4 mb-4 text-sm">{{$t('companies.group_alert')}}</h2>
            </template>
            <template slot="content">

                <div class="mt-2 mb-4" >
                  <label for="switch-enviar-avisos" class="sr-only">
                    {{$t('companies.active')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <div >
                    <el-switch 
                      id="switch-enviar-avisos"
                      :aria-label="$t('companies.active')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisos" 
                      :active-text="$t('companies.active')"></el-switch>
                  </div>
              </div>
              
              <div class="mb-4" v-if="form.tipo === 1 || form.tipo === 2">
                  <label for="switch-enviar-avisos-usuarios" class="sr-only">
                    {{$t('configurations.send_alerts_users')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <div >
                    <el-switch 
                      id="switch-enviar-avisos-usuarios"
                      :aria-label="$t('configurations.send_alerts_users')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisosUsuarios" 
                      @change="toggleAllAlertsUsers"
                      :active-text="$t('configurations.send_alerts_users')"></el-switch>
                  </div>
                  <span class="sr-only" role="status" aria-live="polite" aria-atomic="true">{{ alertsUsersStatusMessage }}</span>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-nueva-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_alerts')}}</span>
                    <el-switch 
                      id="switch-email-aviso-nueva"
                      :aria-label="$t('configurations.email_alerts_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoNueva" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoNueva">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-nueva-label"
                      v-model="form.EmailAvisoNueva"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoNueva" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoNueva = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-descargada-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon v-if="form.tipo === 3"/>{{$t('companies.email_downloads')}}</span>
                    <el-switch 
                      v-if="form.tipo == 1 || form.tipo == 2"
                      id="switch-email-aviso-descargada"
                      :aria-label="$t('configurations.email_downloads_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoDescargada" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoDescargada">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-descargada-label"
                      v-model="form.EmailAvisoDescargada"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoDescargada" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoDescargada = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              
              <div class="lg:mb-2" v-if="hasPermModuleSMS && (form.tipo == 1 || form.tipo === 2)">
                <div class="mandatory">
                  <span id="group-sms-aviso-descargada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.sms_downloads')}}</span>
                  <el-form-item prop="SMSAvisoDescargada">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-sms-aviso-descargada-label"
                      maxlength="9"
                      v-model="form.SMSAvisoDescargada"
                    >
                      <template slot="prepend">{{formatCodigoPaisSMSAvisoDescargada}}</template>
                      <template v-if="form.SMSAvisoDescargada" slot="suffix">
                        <base-clear-input-button
                          class="pt-2"
                          aria-label="Limpiar campo de SMS"
                          @clear="form.SMSAvisoDescargada = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-tramitada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tramitada')}}</span>
                    <el-switch 
                      id="switch-email-aviso-tramitada"
                      :aria-label="$t('configurations.email_tramitada_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoTramitada" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoTramitada">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-tramitada-label"
                      v-model="form.EmailAvisoTramitada"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoTramitada" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoTramitada = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-0" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full lg:mb-0">
                    <div class="flex items-center mb-1">
                      <span id="group-dias-aviso-label" class="text-sm font-semibold text-secondary-600 block">{{$t('companies.download_alert_days_form')}}</span>
                      <base-tooltip-icon size="sm" :content="$t('configurations.days_groups_tooltip')" class="ml-2"/>
                    </div>

                      <el-form-item prop="DiasAviso" class="mb-0">
                        <el-input
                          class="w-full"
                          aria-labelledby="group-dias-aviso-label"
                          v-model="form.DiasAviso"
                          maxlength='5'
                            >
                          <template v-if="form.DiasAviso && form.tipo !== 1" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo de días descarga alerta"
                              @clear="form.DiasAviso = ''"
                            />
                          </template>
                        </el-input>
                      </el-form-item>
                  </div>
                  <div class="px-2 w-full lg:mb-0">
                    <div class="flex items-center mb-1">
                      <span id="group-dias-aviso-fin-tramite-label" class="text-sm font-semibold text-secondary-600 block">{{$t('companies.end_alert_days_label_form')}}</span>
                      <base-tooltip-icon size="sm" :content="$t('configurations.days_groups_tooltip')" class="ml-2"/>
                    </div>
                    <el-form-item prop="DiasAvisoFinTramite" class="mb-0">
                      <el-input
                        class="w-full"
                        aria-labelledby="group-dias-aviso-fin-tramite-label"
                        v-model="form.DiasAvisoFinTramite"
                        maxlength='5'
                        >
                          <template v-if="form.DiasAvisoFinTramite" slot="suffix">
                            <base-clear-input-button
                              aria-label="Limpiar campo de días aviso fin trámite"
                              @clear="form.DiasAvisoFinTramite = ''"
                            />
                          </template>
                        </el-input>
                    </el-form-item>
                  </div>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mt-5 mb-5 mr-20">
                  <label for="switch-agrupar-emails-avisos" class="sr-only">
                    {{$t('configurations.mails_group_status')}}. {{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}
                  </label>
                  <el-switch 
                    id="switch-agrupar-emails-avisos"
                    :aria-label="$t('configurations.mails_group_status')"
                    class="switch-text break-normal" 
                    v-model="form.AgruparEmailsAvisos" 
                    :active-text="$t('configurations.mails_group_status')"></el-switch>
                  </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span v-if="form.AgruparEmailsAvisos" id="group-email-ultima-llamada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.mails_group_status_input')}}</span>
                    <span v-else id="group-email-ultima-llamada-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_ultima_llamada')}}</span>
                    <el-switch 
                      id="switch-email-ultima-llamada"
                      :aria-label="$t(form.AgruparEmailsAvisos ? 'configurations.email_ultima_llamada_grouped_users_single_aria' : 'configurations.email_ultima_llamada_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoDiasAviso" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>

                  <el-form-item prop="EmailAvisoUltimaLlamada">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-ultima-llamada-label"
                      v-model="form.EmailAvisoUltimaLlamada"
                      :maxlength='maxLengthCorreos'
                      >
                        <template v-if="form.EmailAvisoUltimaLlamada" slot="suffix">
                          <base-clear-input-button
                            aria-label="Limpiar campo de emails"
                            @clear="form.EmailAvisoUltimaLlamada = ''"
                          />
                        </template>
                      </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-tramitacion-urgente-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_tramitacion_urgente')}}</span>
                    <el-switch 
                      id="switch-email-tramitacion-urgente"
                      :aria-label="$t('configurations.email_tramitacion_urgente_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoTramitacionUrgente">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-tramitacion-urgente-label"
                      v-model="form.EmailAvisoTramitacionUrgente"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoTramitacionUrgente" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoTramitacionUrgente = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>
              <div class="lg:mb-2" v-if="form.AgruparEmailsAvisos === false && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-errores-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_neos_error')}}</span>
                    <el-switch 
                      id="switch-email-neos_error"
                      :aria-label="$t('configurations.email_neos_error_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoErrores" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoErrores">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-errores-label"
                      v-model="form.EmailAvisoErrores"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoErrores" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoErrores = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.tipo === 1 || form.tipo === 2">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-vinculaciones-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_vincul')}}</span>
                    <el-switch 
                      id="switch-email-aviso-vincul"
                      :aria-label="$t('configurations.email_aviso_vincul_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoVinculaciones" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoVinculaciones">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-vinculaciones-label"
                      v-model="form.EmailAvisoVinculaciones"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoVinculaciones" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoVinculaciones = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="hasModuleFlujoEstadosAvisos && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-principal-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_princ')}}</span>
                    <el-switch 
                      id="switch-email-aviso-princ"
                      :aria-label="$t('configurations.email_aviso_princ_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoPrincipal" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoPrincipal">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-principal-label"
                      v-model="form.EmailAvisoPrincipal"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoPrincipal" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoPrincipal = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="hasModuleFlujoEstadosAvisos && (form.tipo === 1 || form.tipo === 2)">
                <div class="mandatory">
                  <div class="switch-row">
                    <span id="group-email-aviso-secundario-label" class="text-sm font-semibold text-secondary-600 block mb-1">{{$t('companies.email_aviso_sec')}}</span>
                    <el-switch 
                      id="switch-email-aviso-sec"
                      :aria-label="$t('configurations.email_aviso_sec_users_single_aria')"
                      class="switch-text break-normal" 
                      v-model="form.EnviarAvisoUsuariosEmailAvisoSecundario" 
                      :active-text="$t('configurations.send_alerts_users_single')" 
                      />
                  </div>
                  <el-form-item prop="EmailAvisoSecundario">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-email-aviso-secundario-label"
                      v-model="form.EmailAvisoSecundario"
                      :maxlength='maxLengthCorreos'
                      >
                      <template v-if="form.EmailAvisoSecundario" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de emails"
                          @clear="form.EmailAvisoSecundario = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="(hasModuleCustomSMTPCliente || (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) && form.tipo && form.tipo !== 3"
            ref="baseCollapsibleCustomMailSmtp" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.custom_mail_smtp')}}</h2>
                <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.groups.contentTooltipSMTP')" 
                  class="ml-2"/>
              </div>
            </template>
            <template slot="content">

            <div class="mb-4">
              <label for="switch-smtp-main" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                {{$t('smtp.main')}}
                <span class="sr-only">{{$t('app.options')}}: {{$t('smtp.default_group')}} / {{$t('smtp.custom')}}</span>
              </label>
              <el-switch 
                id="switch-smtp-main"
                :aria-label="$t('smtp.main')"
                class="switch-text break-normal both-switch mt-2" 
                v-model="form.smtpMain" 
                :active-text="$t('smtp.custom')"
                :inactive-text="$t('smtp.default_group')"
                inactive-color="var(--primary-800)"
                />
            </div>

            <div v-if="form.smtpMain">
              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="group-smtp-server-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.server')}}</span>
                  <el-form-item prop="smtpServer">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-server-label"
                      v-model="form.smtpServer"
                      maxlength='200'
                      >
                      <template v-if="form.smtpServer" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de servidor SMTP"
                          @clear="form.smtpServer = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="group-smtp-from-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.from')}}</span>
                  <el-form-item prop="smtpFrom">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-from-label"
                      v-model="form.smtpFrom"
                      maxlength='100'
                      >
                      <template v-if="form.smtpFrom" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de email remitente SMTP"
                          @clear="form.smtpFrom = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2">
                <div class="mandatory">
                  <span id="group-smtp-port-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.port')}}</span>
                  <el-form-item prop="smtpPort">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-port-label"
                      v-model.number="form.smtpPort"
                      maxlength='10'
                      >
                      <template v-if="form.smtpPort" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de puerto SMTP"
                          @clear="form.smtpPort = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="mb-4">
                <label for="switch-smtp-ssl" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.ssl')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-ssl"
                  :aria-label="$t('smtp.ssl')"
                  class="switch-text break-normal both-switch mt-2" 
                  v-model="form.smptSSL" 
                  :active-text="$t('companies.active')"/>
              </div>
              
              <div class="mb-4">
                <label for="switch-smtp-relay" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.relay')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('companies.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-relay"
                  :aria-label="$t('smtp.relay')"
                  class="switch-text break-normal both-switch mt-2" 
                  :disabled="form.smptOAuth2"
                  v-model="form.smtpRelay" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="mb-4">
                <label for="switch-smtp-oauth2" class="text-sm font-semibold text-secondary-600 block mb-1 flex flex-col">
                  {{$t('smtp.oauth2')}}
                  <span class="sr-only">{{$t('app.options')}}: {{$t('app.inactive')}} / {{$t('app.active')}}</span>
                </label>
                <el-switch 
                  id="switch-smtp-oauth2"
                  :aria-label="$t('smtp.oauth2')"
                  class="switch-text break-normal both-switch mt-2" 
                  :disabled="form.smtpRelay"
                  v-model="form.smptOAuth2" 
                  :active-text="$t('companies.active')"/>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <span id="group-smtp-client-id-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.clientid')}}</span>
                  <el-form-item prop="smptClientId">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-client-id-label"
                      v-model="form.smptClientId"
                      maxlength='100'
                      >
                      <template v-if="form.smptClientId" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de Client ID SMTP"
                          @clear="form.smptClientId = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="form.smptOAuth2">
                <div class="mandatory">
                  <span id="group-smtp-tenant-id-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.tenantid')}}</span>
                  <el-form-item prop="smptTenantId">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-tenant-id-label"
                      v-model="form.smptTenantId"
                      maxlength='100'
                      >
                      <template v-if="form.smptTenantId" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de Tenant ID SMTP"
                          @clear="form.smptTenantId = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="!form.smtpRelay">
                <div class="mandatory">
                  <span id="group-smtp-user-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.user')}}</span>
                  <el-form-item prop="smtpUser">
                    <el-input
                      class="w-full"
                      aria-labelledby="group-smtp-user-label"
                      v-model="form.smtpUser"
                      maxlength='100'
                      >
                      <template v-if="form.smtpUser" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de usuario SMTP"
                          @clear="form.smtpUser = ''"
                        />
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
              </div>

              <div class="lg:mb-2" v-if="!form.smtpRelay">
                <div class="mandatory">
                  <span id="group-smtp-pass-label" class="text-sm font-semibold text-secondary-600 block mb-1"><base-obligatory-icon/>{{$t('smtp.pass')}}</span>
                  <el-form-item prop="smtpPass">
                    <el-input
                      ref="passwordInputPassGroup"
                      aria-labelledby="group-smtp-pass-label"
                      :disabled="disableEditPass"
                      show-password
                      class="w-full"
                      v-model="form.smtpPass"
                      autocomplete="new-password"
                      maxlength='100'
                    >
                      <template v-if="form.smtpPass && !disableEditPass" slot="suffix">
                        <base-clear-input-button
                          aria-label="Limpiar campo de contraseña SMTP"
                          @clear="form.smtpPass = ''"
                        />
                      </template>
                      <base-button-icon
                        v-if="visibleEditPass"
                        slot="append" 
                        @click="editSmtpPassToggle()"
                        :name="disableEditPass ? 'editpencil' : 'cross'"
                        :ariaLabel="disableEditPass ? 'Editar contraseña' : 'Cancelar edición de contraseña'"
                        iconSize="md"
                        size="xs"
                        mode="primary-phantom"
                        class="bg-primary-100 hover:bg-primary-200 dark:bg-darkblue-800 dark:text-darkblue-200 rounded-full"
                      />
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </div>

            </template>
          </base-collapsible-form>

          <base-collapsible-form 
            v-if="!isGeneralLoading && !isCreate && form.tipo !== 3"
            ref="baseCollapsibleWhiteEmails" 
            class="mt-2 bg-white dark:bg-darkblue-900 rounded-lg border-solid border-primary-300 dark:border-darkblue-600 border pr-4 pl-4 mb-2">
            <template slot="headerRight">
              <div class="flex items-center mt-4 mb-4">
                <h2 class="dark:text-darkblue-200 font-bold text-sm">{{$t('clients.config_admin_white_list_emails')}}</h2>
                <base-tooltip-icon 
                  size="sm" 
                  :content="$t('tooltip.groups.contentTooltipWhiteList')" 
                  class="ml-2"/>
              </div>
            </template>
            <template slot="content">
              <el-table
                ref="whitelistemails"
                :data="formUnwatchable.ListaBlancaEmails"
                style="width: 100%"
                max-height="250"
                :show-header="false">
                <el-table-column
                  prop="Nombre"
                  label="Nombre"
                  show-overflow-tooltip>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  width="80"
                  align="center"
                  label="-">
                  <template slot-scope="scope">
                    <div class="flex flex-row">
                      <!-- <base-button-icon @click="editListaBlancaEmail(scope.row)" name="editpencil" mode="core" size="xs" /> -->
                      <base-button-icon @click="deleteListaBlancaEmail(scope.row, scope.$index)" name="trash" mode="core" size="xs" ariaLabel="Eliminar email de lista blanca" />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <div class="w-full flex flex-wrap justify-end items-center gap-x-2 mt-5 mb-5">
                <base-button-responsive
                    v-if="visibleDeleteAllWhiteMail"
                    mode="primary"
                    :text="$t('app.delete_all')"
                    @click="deleteAllWhiteMailToggleDialog()"
                    icon="trash"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.export_excel')"
                    @click="exportExcelWhiteMail()"
                    icon="excelxls"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('app.import_emails')"
                    @click="toggleImportEmail()"
                    icon="import"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
                  <base-button-responsive
                    mode="primary"
                    :text="$t('clients.add_email')"
                    @click="newWhiteMailToggleDialog()"
                    icon="plus"
                    :loading="isGeneralLoading"
                    :disabled="isGeneralLoading"
                  />
              </div>
            </template>
          </base-collapsible-form>
          
          </div>
        </el-form>
      </div>
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive
            mode="secondary"
            :text="isCreate ? $t('app.cancel') : $t('app.back')"
            icon="cross"
            @click="goBack"
            :loading="isGeneralLoading"
          />
          <base-button-responsive 
            mode="primary" 
            v-if="
             (hasModuleCustomSMTPCliente || (hasModuleCustomSMTPZerocoma && role === 'SuperAdministrador')) &&
             !isCreate && 
             showTestHotFolder && 
             form.smtpMain" 
            :text="$t('app.test_btn_smtp')" 
            icon="mailtest" 
            @click="submitForm('ruleForm', true)" 
            :loading="isGeneralLoading" 
            :disabled="isGeneralLoading"
          />
          <base-button-responsive
            mode="primary"
            :text="$t('app.save')"
            icon="save"
            @click="submitForm('ruleForm')"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          />
        </template>
      </base-footer>
      <BaseElDialog
        :title="$t('clients.delete_white_list_emails')"
        :visible.sync="showModalDeleteWhiteMail"
        @open="handleOpenModalDialog('container-handleOpenModal-delete-neo')"
        @closed="releaseFocusDialog"
        width="40%"
        custom-class="min-width-dialog"
        center
        :show-close="false">
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteWhiteMail }}</span>
        <template slot="footer" >
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2" ref="container-handleOpenModal-delete-neo">
            <base-button class="w-full" @click="showModalDeleteWhiteMail = false" mode="secondary-phantom-blue" :text="$t('app.cancel')"/>
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')" @click="() => {submitActionDeleteWhiteMail(); showModalDeleteWhiteMail = false}"/>
          </div>
        </template>
      </BaseElDialog>
      <input-text-mail-dialog 
        :dialogOpen="showModalHotFolder" 
        @toggleDialog="toggleModalHotFolder" 
        @applyDialog="testHotFolder"
        header="Enviar email de prueba" 
        headerValue="Destinatario" 
        />
      <input-text-mail-dialog 
        :dialogOpen="showModalWhiteMail" 
        @toggleDialog="newWhiteMailToggleDialog" 
        @applyDialog="applyNewWhiteMailDialog"
        header="Añadir nuevo email a la lista blanca" 
        headerValue="Nuevo email" 
        />
        <import-generic-dialog
          :vuexNamespace="vuexnamespace"
          :dialogOpen="showModalImportEmail" 
          @toggleDialog="toggleImportEmail" 
          @applyDialog="applyImportEmail"
          @downloadTemplate="downloadTemplateEmail"
          :getClientActive="false"
          header="Importación de Emails" 
          />
    </template>
  </detail-layout-full-width>
</template>

<script>
import { bus } from '@/main'
import DetailLayoutFullWidth from '@/components/layout/DetailLayoutFullWidth.vue'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'
import { getClients } from '@/services/clients/getClients'
import { getGroup } from '@/services/configurations/groups/getGroup'
import { newGroup } from '@/services/configurations/groups/newGroup'
import { updateGroup } from '@/services/configurations/groups/updateGroup'
import { getGroupTemplate } from '@/services/configurations/groups/template/getGroupTemplate'
import { deleteWhiteListEmails } from '@/services/configurations/groups/deleteWhiteListEmails'
import { newWhiteListEmails } from '@/services/configurations/groups/newWhiteListEmails'
import { getWhiteListEmails } from '@/services/configurations/groups/getWhiteListEmails'
import { getWhiteMailGroupExcel } from '@/services/clients/getWhiteMailGroupExcel' 
import { deleteAllWhiteGroupListEmails } from '@/services/clients/lists/deleteAllWhiteGroupListEmails'

import { i18n } from '@/i18n'
import { TIPOS_GRUPO } from '@/config/tipos-grupo'
import InputTextMailDialog from '@/components/InputTextMailDialog.vue'
import { email as emailRegex } from '@/utils/regex'

import ImportGenericDialog from '@/components/ImportGenericDialog.vue'
import { importListaBlancaEmailsGrupo } from '@/services/configurations/imports/importListaBlancaEmailsGrupo'
import { downloadTemplateListaBlancaEmails } from '@/services/configurations/imports/downloadTemplateListaBlancaEmails'

import { enviocorreoprueba } from '@/services/clients/enviocorreoprueba' 
import BaseElDialog from '@/components/base/BaseElDialog.vue'

function isValidNum (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 999999) {
      return true
    }
  }
  return false
}
function isValidEmail (value) {
  return value.split(';').every(item => emailRegex.test(item))
}
function isValidPhoneNumberES (value) {
  const pattern = /^\d{9}$/
  if (Number.isInteger(parseFloat(value))) {
    if (value.match(pattern)) {
      return true
    }
  }
  return false
}
function isValidDay (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 8) {
      return true
    }
  }
  return false
}
function isValidDayDownload (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 10) {
      return true
    }
  }
  return false
}
function isValidDayEnd (value) {
  if (Number.isInteger(parseFloat(value))) {
    if (value >= 0 && value <= 30) {
      return true
    }
  }
  return false
}

export default {
  /* eslint-disable camelcase */
  name: 'group-detail',
  components: {
    DetailLayoutFullWidth,
    AccessibleElSelect,
    InputTextMailDialog,
    ImportGenericDialog,
    BaseElDialog,
  },
  data: function () {
    return {
      alertsUsersStatusMessage: '',
      searchView: false,
      activeName: 'es',
      localUserId: null,
      header: {
        title: 'DETALLE DE GRUPO',
        icon: 'config',
        breadcrumb: {},
        nav: [],
        url: 'configurations/groups'
      },
      showModalHotFolder: false,
      showTestHotFolder: false,
      maxLengthCorreos: 500,
      availableUpdateVerTodoStatuses: false,
      availableUpdateVerTodoCompanies: false,
      visibleEditPass: false,
      disableEditPass: false,
      form: this.getDefaultForm(),
      formUnwatchable: this.getDefaultFormUnwatchable(),
      firstLoadView: true,
      template: {
        verTodoAsignarGrupos: true,
        verTodoGroups: false,
        verTodoStatuses: true,
        verTodoCompanies: true,
      },
      showModalWhiteMail: false,
      showModalImportEmail: false,
      showModalDeleteWhiteMail: false,
      processMessageDeleteWhiteMail: this.$i18n.t('clients.delete_white_list_emails_msg'),
      tiposGrupo: TIPOS_GRUPO,
      clientes: [],
      tooltipverTodoGroups: this.$i18n.t('tooltip.groups.ver_todo_groups'),
      tooltipVerTodoStatuses: this.$i18n.t('tooltip.groups.ver_todo_statuses'),
      tooltipVerTodoCompanies: this.$i18n.t('tooltip.groups.ver_todo_companies'),
      tooltipTipoGrupo: this.$i18n.t('tooltip.html.groups.tipo_grupo'),
      values: [
        {
          value: true,
          label: i18n.t('app.yes')
        },
        {
          value: false,
          label: i18n.t('app.no')
        }
      ],
    }
  },
  computed: {
    alertsUsersFields () {
      return Object.keys(this.form).filter(key => key.startsWith('EnviarAvisoUsuariosEmailAviso'))
    },
    // Solo los switches visibles: los ocultos por AgruparEmailsAvisos o por módulo no pueden marcarse
    visibleAlertsUsersFields () {
      const grouped = this.form.AgruparEmailsAvisos !== false
      return this.alertsUsersFields.filter(field => {
        if (field.endsWith('TramitacionUrgente') || field.endsWith('Errores')) return !grouped
        if (field.endsWith('Principal') || field.endsWith('Secundario')) return this.hasModuleFlujoEstadosAvisos
        return true
      })
    },
    visibleAlertsUsersValues () {
      return this.visibleAlertsUsersFields.map(field => this.form[field])
    },
    allAlertsUsersActive () {
      return this.visibleAlertsUsersValues.length > 0 && this.visibleAlertsUsersValues.every(Boolean)
    },
    empresaFilter () {
      return this.isCreate ? this.$store.getters['groups/getMasterFilters']?.empresa?.value || null : null
    },
    visibleDeleteAllWhiteMail () {
      return this.formUnwatchable?.ListaBlancaEmails?.length > 0
    },
    isPasswordSmtpVisible () {
      return this.form.smtpMain && ((this.hasModuleCustomSMTPCliente || (this.hasModuleCustomSMTPZerocoma && this.role === 'SuperAdministrador')) && this.form.tipo && this.form.tipo !== 3) && (!this.form.smtpRelay)
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    id: function () {
      return this.$route.params.id ? parseInt(this.$route.params.id) : null
    },
    isCreate: function () {
      return this.id === -1 || this.id === '-1'
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasPermissionEditVisiblity () {
      return this.$store.getters['auth/hasPermissionEditVisiblity']
    },
    hasModuleGruposReparto () {
      return this.$store.getters['auth/hasModuleGruposReparto']
    },
    hasModulePermisosGruposTraspasoNEOs () {
      return this.$store.getters['auth/hasModulePermisosGruposTraspasoNEOs']
    },
    hasModuleCustomSMTPCliente () {
      return this.$store.getters['auth/hasModuleCustomSMTPCliente']
    },
    hasModuleCustomSMTPZerocoma () {
      return this.$store.getters['auth/hasModuleCustomSMTPZerocoma']
    },
    hasModuleFlujoEstadosAvisos () {
      return this.$store.getters['auth/hasModuleFlujoEstadosAvisos']
    },
    hasAnyImportaciones () {
      return this.$store.getters['auth/hasAnyImportaciones']
    },
    tiposGrupoFiltered () {
      if (this.isCreate) {
        if (this.hasModuleGruposReparto) return this.tiposGrupo.filter(x => x.create)
        return this.tiposGrupo.filter(x => x.create).filter(x => x.id !== 3)
      } else return this.tiposGrupo
    },
    clientesForAccessibleSelect () {
      return this.clientes.map(cliente => ({
        id: cliente.IdEmpresa,
        value: cliente.IdEmpresa,
        name: cliente.Nombre
      }))
    },
    tiposGrupoFilteredForAccessibleSelect () {
      return this.tiposGrupoFiltered.map(tipo => ({
        id: tipo.id,
        value: tipo.id,
        name: tipo.name
      }))
    },
    // contentTooltipEmail () {
    //   if (this.form.tipo === 2) return 'Bandeja de emails utilizada para avisos de notificaciones nuevas, descargadas y tramitadas, en caso de tener configurado los avisos a grupos'
    //   if (this.form.tipo === 3) return 'Bandeja de emails utilizada para avisos de notificaciones descargadas'
    //   return ''
    // },
    formatCodigoPaisSMSAvisoDescargada () {
      if (this.form?.CodigoPaisSMSAvisoDescargada === '0034') return '+34'
      return 'Desconocido'
    },
    hasPermModuleSMS () {
      return this.$store.getters['auth/hasModuleEnvioSMS']
    },
    isTipoReparto () {
      return this.form?.tipo === 3
    },
    rules () {
      return {
        clienteId: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        name: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        tipo: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isGenericValidation, trigger: 'change' }
        ],
        EmailAvisoNueva: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoDescargada: [
          {
            required: this.isTipoReparto,
            message: this.$i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          { required: this.isTipoReparto, validator: this.isEmailValid, trigger: 'blur' }
        ],
        SMSAvisoDescargada: [
          { required: false, validator: this.isNumberPhoneValid, trigger: 'blur' }
        ],
        EmailAvisoTramitada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoVinculaciones: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoPrincipal: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoSecundario: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoUltimaLlamada: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoTramitacionUrgente: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        EmailAvisoErrores: [
          { required: false, validator: this.isEmailValid, trigger: 'blur' }
        ],
        DiasAviso: [
          { required: false, validator: this.isDayValid, trigger: 'blur' }
        ],
        DiasAvisoFinTramite: [
          { required: false, validator: this.isDayValidEnd, trigger: 'blur' }
        ],
        
        smtpServer: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpFrom: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { validator: this.isEmailValidSingle, trigger: 'blur' }
        ],
        smtpPort: [
          { validator: this.isGenericValidation, trigger: 'blur' },
          { required: true, validator: this.isNumberValid, trigger: 'blur' }
        ],
        smptClientId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smptTenantId: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpUser: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
        smtpPass: [
          { validator: this.isGenericValidation, trigger: 'blur' }
        ],
      }
    }
  },
  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: 'watchFormHandler'
    },
    'form.tipo': {
      deep: true,
      immediate: true,
      handler: 'watchFormHandlerTipo'
    },
    // Se dispara ante cualquier cambio en los avisos visibles, no solo cuando cambia el resultado de "todos activos"
    visibleAlertsUsersValues () {
      if (this.form.tipo === 1 || this.form.tipo === 2) this.form.EnviarAvisosUsuarios = this.allAlertsUsersActive
    },
    isPasswordSmtpVisible: function (value, oldValue) {
      if (value) this.fixAccesibilityElInputPass()
    },
  },
  created: async function () {
    this.$store.commit('setIsLoading', true)
    const breadcrumbs = []

    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      }
      this.clientes = dataClients.Empresas
      if (this.isCreate) this.preSelectClient(this.form, 'clienteId')

      breadcrumbs.push({
        path: this.role === 'SuperAdministrador' ? 'configurationssa' : 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    } else {
      breadcrumbs.push({
        path: 'configurations',
        name: this.$i18n.t('app.configurations')
      })
    }
    breadcrumbs.push({ path: 'configurations/groups', name: this.$i18n.t('app.groups') })

    if (!this.isCreate) {
      await this.downloadData(this.id)
      if (this.form.tipo === 3) {
        this.$refs.baseCollapsibleAlerts.openAndDisable()
      }
      breadcrumbs.push({ path: '', name: this.form.name })
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    } else {
      breadcrumbs.push({
        path: '',
        name: this.$i18n.t('configurations.new_group')
      })
      if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'SuperAdministrador') {
        const template = await getGroupTemplate()
        if (template.blnError === true) {
          this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
        }
        this.setTemplate(template.respuesta)
      }
      this.$store.commit('setIsLoading', false)
    }
    this.header.breadcrumb = breadcrumbs
  },
  mounted () {
    this.resetControlFormChanges()
    this.fixAccesibilityElInputPass()
  },
  methods: {
    toggleAllAlertsUsers (value) {
      this.visibleAlertsUsersFields.forEach(field => {
        this.form[field] = value
      })
      this.alertsUsersStatusMessage = this.$t(value ? 'configurations.send_alerts_users_all_enabled' : 'configurations.send_alerts_users_all_disabled')
    },
    deleteAllWhiteMailToggleDialog () {
      this.showModalDeleteWhiteMail = !this.showModalDeleteWhiteMail
    },
    submitActionDeleteWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        await this.exportExcelWhiteMail()
        const params = { idGrupo: this.id } 
        const response = await deleteAllWhiteGroupListEmails(params)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.downloadListwhiteEmail()
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    exportExcelWhiteMail: async function () {
      this.$store.commit('app/setLoading', true)
      try {
        const params = { idGrupo: this.id } 
        const response = await getWhiteMailGroupExcel(params)
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        let filename = 'lista-blanca-emails.xlsx'
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    fixAccesibilityElInputPass () {
      this.$nextTick(() => {
      // Timeout para esperar a que se rendericen los iconos
        setTimeout(() => {
          this.fixAccesibilityElInputPassword(this.$refs.passwordInputPassGroup, this.$i18n.t('aria.elementui.input.password'))
        }, 1000)
      })
    },
    getDefaultForm: function () {
      return {
        id: 2,
        name: '',
        email: '',
        tipo: 2,
        EnUso: false,
        company: '',
        active: false,
        clienteId: null,
        verTodoGroups: false,
        verTodoAsignarGrupos: true,
        Descripcion: '',
        verTodoStatuses: true,
        verTodoCompanies: true,
        EmailAvisoNueva: '',
        EmailAvisoDescargada: '',
        CodigoPaisSMSAvisoDescargada: '0034',
        SMSAvisoDescargada: '',
        EmailAvisoTramitada: '',
        EmailAvisoVinculaciones: '',
        EmailAvisoPrincipal: '',
        EmailAvisoSecundario: '',
        DiasAviso: null,
        DiasAvisoFinTramite: null,
        AgruparEmailsAvisos: true,
        EmailAvisoUltimaLlamada: '',
        EmailAvisoTramitacionUrgente: '',
        EmailAvisoErrores: '',
        EnviarAvisos: true,
        EnviarAvisosUsuarios: false,
        EnviarAvisoUsuariosEmailAvisoNueva: false,
        EnviarAvisoUsuariosEmailAvisoDescargada: false,
        EnviarAvisoUsuariosEmailAvisoTramitada: false,
        EnviarAvisoUsuariosEmailAvisoDiasAviso: false,
        EnviarAvisoUsuariosEmailAvisoTramitacionUrgente: false,
        EnviarAvisoUsuariosEmailAvisoErrores: false,
        EnviarAvisoUsuariosEmailAvisoVinculaciones: false,
        EnviarAvisoUsuariosEmailAvisoPrincipal: false,
        EnviarAvisoUsuariosEmailAvisoSecundario: false,
        // ListaBlancaEmails: [],
        smtpMain: false,
        smtpServer: null,
        smtpFrom: null,
        smtpPort: null,
        smptSSL: true,
        smptOAuth2: null,
        smtpRelay: false,
        smptClientId: null,
        smptTenantId: null,
        smtpUser: null,
        smtpPass: null,
      }
    },
    getDefaultFormUnwatchable () {
      return {
        ListaBlancaEmails: [],
      }
    },
    toggleModalHotFolder () {
      this.showModalHotFolder = !this.showModalHotFolder
    },
    testHotFolder: async function (destinatario) {
      try {
        this.$store.commit('setIsLoading', true)
        const res = await enviocorreoprueba({ 
          idGrupo: this.id,
          destinatario: destinatario,
        })
        if (res.blnError) {
          this.doFeedback(res.msgError + ' [Código de error: ' + res.codError + ']')
        } else {
          this.toggleModalHotFolder()
          this.doFeedback('Prueba realizada correctamente', 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadListwhiteEmail: async function () {
      try {
        const payload = { idGrupo: this.id }
        const result = await getWhiteListEmails(payload)
        if (result.blnError === true) {
          this.doFeedback(result.msgError + ' [Código de error: ' + result.codError + ']')
        } else {
          this.formUnwatchable.ListaBlancaEmails = result.Respuesta.map(x => ({ Nombre: x }))
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.resetControlFormChanges()
      }
    },
    applyNewWhiteMailDialog: async function (email) {
      try {
        const payload = { Email: email, idGrupo: this.id }
        const response = await newWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          this.newWhiteMailToggleDialog()
          // Añadimos a lista
          this.formUnwatchable.ListaBlancaEmails.push({ Nombre: email })
          // this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
      }
    },
    applyImportEmail: async function (file) {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await importListaBlancaEmailsGrupo(file, { idGrupo: this.id })
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.toggleImportEmail() 
          this.doFeedback('Procesando importación. Puede consultar el estado en esta vista.', 'info')
          if (!this.hasAnyImportaciones) {
            bus.$emit('resetAndUpdateNav', 1000)
          }
          this.$router.push({ name: 'configurations/imports' })
        } 
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadTemplateEmail: async function () {
      this.$store.commit('setIsLoading', true)
      try {
        const response = await downloadTemplateListaBlancaEmails()
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.downloadBlob(response, 'plantilla-importacion-emails.xlsx')
        }
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    deleteListaBlancaEmail: async function (row, index) {
      try {
        const payload = { Email: row.Nombre, idGrupo: this.id }
        const response = await deleteWhiteListEmails(payload)
        if (response.blnError === true) {
          this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
        } else {
          this.doFeedback('Acción tramitada con éxito', 'success')
          // Eliminamos fila en tabla, no es necesario volver a hacer llamada
          this.formUnwatchable.ListaBlancaEmails.splice(index, 1)
          // this.downloadListwhiteEmail()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
      }
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    goDetailClient () {
      const id = this.form.clienteId
      this.$router.push({ name: 'configurations/clients/details', params: { id } })
    },
    watchFormHandler () {
      this.$store.commit('app/setFormChanges', true)
    },
    watchFormHandlerTipo: function () {
      // Gestion y GestorNEOs
      if (this.form.tipo === 2 || this.form.tipo === 1) {
        setTimeout(() => {
          this.$refs.baseCollapsibleAlerts.restoreDisable()
        }, 300)
      }
      if (this.form.tipo === 2) {
        this.form.verTodoAsignarGrupos = true
        this.form.verTodoGroups = this.template.verTodoGroups
        this.form.verTodoCompanies = this.template.verTodoCompanies
        this.form.verTodoStatuses = this.template.verTodoStatuses
      }
      // Reparto
      if (this.form.tipo === 3) {
        this.$refs.baseCollapsibleAlerts.openAndDisable()
        this.form.verTodoAsignarGrupos = true
        this.form.verTodoGroups = false
        this.form.verTodoCompanies = false
        this.form.verTodoStatuses = false
      }
        
      if (this.isCreate && !this.firstLoadView) {
        setTimeout(() => {
          this.doFeedback(this.$i18n.t('app.alert_form_changes'), 'info')
        }, 200)
      } else {
        this.firstLoadView = false
      }
    },
    toggleSearchView: function () {
      this.searchView = !this.searchView
    },
    toggleImportEmail () {
      this.showModalImportEmail = !this.showModalImportEmail
    },
    isEmailValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidEmail(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_multiple'), callback)
      } else if (value.length > this.maxLengthCorreos) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email_length') + this.maxLengthCorreos + ' caracteres', callback)
      } else {
        callback()
      }
    },
    isEmailValidSingle: function (rule, value, callback) {
      if (!value) {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
      }
      if (!emailRegex.test(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.email'), callback)
      } else {
        callback()
      }
    },
    isNumberValid: function (rule, value, callback) {
      if (!value || value === '') {
        return this.doAriaLiveAndReturnCallback(i18n.t('validation.complete'), callback)
        // callback()
      } else if (!isValidNum(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.number'), callback)
      } else {
        callback()
      }
    },
    isDayValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDay(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso'), callback)
      } else {
        callback()
      }
    },
    isDayValidDownload: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayDownload(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_download'), callback)
      } else {
        callback()
      }
    },
    isDayValidEnd: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidDayEnd(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.aviso_fin_tramite'), callback)
      } else {
        callback()
      }
    },
    isNumberPhoneValid: function (rule, value, callback) {
      if (!value) {
        callback() // queremos que la validación sea opcional en este caso.
      } else if (!isValidPhoneNumberES(value)) {
        this.doAriaLiveAndReturnCallback(i18n.t('validation.template.sms'), callback)
      } else {
        callback()
      }
    },
    submitForm: function (formName, test = false) {
      if (this.isCreate) {
        this.newGroupHandler(formName)
      } else {
        this.updateGroupHandler(formName, test)
      }
    },
    newGroupHandler: function (formName) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idEmpresa: this.form.clienteId,
            Nombre: this.form.name,
            Emails: this.form.email,
            idTipo: this.form.tipo,
            verTodoGrupos: this.form.verTodoGroups,
            verTodoAsignarGrupos: this.form.verTodoAsignarGrupos,
            Descripcion: this.form.Descripcion,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            NumeroSMSDescargadas: this.form.SMSAvisoDescargada ? (this.form.CodigoPaisSMSAvisoDescargada + '' + this.form.SMSAvisoDescargada) : null,
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EmailAvisoPrincipal: this.form.EmailAvisoPrincipal,
            EmailAvisoSecundario: this.form.EmailAvisoSecundario,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EnviarAvisoUsuariosEmailAvisoNueva: this.form.EnviarAvisoUsuariosEmailAvisoNueva,
            EnviarAvisoUsuariosEmailAvisoDescargada: this.form.EnviarAvisoUsuariosEmailAvisoDescargada,
            EnviarAvisoUsuariosEmailAvisoTramitada: this.form.EnviarAvisoUsuariosEmailAvisoTramitada,
            EnviarAvisoUsuariosEmailDiasAviso: this.form.EnviarAvisoUsuariosEmailAvisoDiasAviso,
            EnviarAvisoUsuariosEmailAvisoTramitacionUrgente: this.form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente,
            EnviarAvisoUsuariosEmailAvisoErrores: this.form.EnviarAvisoUsuariosEmailAvisoErrores,
            EnviarAvisoUsuariosEmailAvisoVinculaciones: this.form.EnviarAvisoUsuariosEmailAvisoVinculaciones,
            EnviarAvisoUsuariosEmailAvisoPrincipal: this.form.EnviarAvisoUsuariosEmailAvisoPrincipal,
            EnviarAvisoUsuariosEmailAvisoSecundario: this.form.EnviarAvisoUsuariosEmailAvisoSecundario,
            DiasAviso: parseInt(this.form.DiasAviso),
            DiasFinTramite: parseInt(this.form.DiasAvisoFinTramite),
            ConfigSMTP: this.form.tipo !== 3
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptClientId,
                TenantId: this.form.smptTenantId,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
          }
          const response = await newGroup(params)
          if (response.blnError === true) {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          } else {
            this.resetForm()
            this.doFeedback('Datos guardados correctamente', 'success')
            if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor' && this.role !== 'SuperAdministrador') {
              const template = await getGroupTemplate()
              if (template.blnError === true) {
                this.doFeedback(template.msgError + ' [Código de error: ' + template.codError + ']')
              }
              this.setTemplate(template.respuesta)
            } else {
              this.form = this.getDefaultForm()
              this.formUnwatchable = this.getDefaultFormUnwatchable()
              this.resetControlFormChanges()
              if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
                this.preSelectClient(this.form, 'clienteId')
              }
            }
            this.resetForm()
            // setTimeout(() => {
            //   this.resetForm()
            // }, 100)
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    resetForm () {
      this.$refs.ruleForm.resetFields()
    },
    updateGroupHandler: function (formName, test = false) {
      this.$store.commit('setAjaxRequestPending', true)
      this.$store.commit('setIsLoading', true)
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          // TODO Dependiendo del tipo de grupo
          const params = {
            idGrupo: this.form.id,
            Nombre: this.form.name,
            Emails: this.form.email,
            verTodoGrupos: this.form.verTodoGroups,
            verTodoAsignarGrupos: this.form.verTodoAsignarGrupos,
            Descripcion: this.form.Descripcion,
            VerTodoEstados: this.form.verTodoStatuses,
            VerTodoEmpresas: this.form.verTodoCompanies,
            NumeroSMSDescargadas: this.form.SMSAvisoDescargada ? (this.form.CodigoPaisSMSAvisoDescargada + '' + this.form.SMSAvisoDescargada) : null,
            EmailAvisoNueva: this.form.EmailAvisoNueva,
            EmailAvisoDescargada: this.form.EmailAvisoDescargada,
            EmailAvisoTramitada: this.form.EmailAvisoTramitada,
            EmailAvisoVinculaciones: this.form.EmailAvisoVinculaciones,
            EmailAvisoPrincipal: this.form.EmailAvisoPrincipal,
            EmailAvisoSecundario: this.form.EmailAvisoSecundario,
            EmailDiasAviso: this.form.EmailAvisoUltimaLlamada,
            EmailAvisoTramitacionUrgente: this.form.EmailAvisoTramitacionUrgente,
            EmailAvisoErrores: this.form.EmailAvisoErrores,
            AgruparEmailsAvisos: this.form.AgruparEmailsAvisos,
            EnviarAvisos: this.form.EnviarAvisos,
            EnviarAvisosUsuarios: this.form.EnviarAvisosUsuarios,
            EnviarAvisoUsuariosEmailAvisoNueva: this.form.EnviarAvisoUsuariosEmailAvisoNueva,
            EnviarAvisoUsuariosEmailAvisoDescargada: this.form.EnviarAvisoUsuariosEmailAvisoDescargada,
            EnviarAvisoUsuariosEmailAvisoTramitada: this.form.EnviarAvisoUsuariosEmailAvisoTramitada,
            EnviarAvisoUsuariosEmailDiasAviso: this.form.EnviarAvisoUsuariosEmailAvisoDiasAviso,
            EnviarAvisoUsuariosEmailAvisoTramitacionUrgente: this.form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente,
            EnviarAvisoUsuariosEmailAvisoErrores: this.form.EnviarAvisoUsuariosEmailAvisoErrores,
            EnviarAvisoUsuariosEmailAvisoVinculaciones: this.form.EnviarAvisoUsuariosEmailAvisoVinculaciones,
            EnviarAvisoUsuariosEmailAvisoPrincipal: this.form.EnviarAvisoUsuariosEmailAvisoPrincipal,
            EnviarAvisoUsuariosEmailAvisoSecundario: this.form.EnviarAvisoUsuariosEmailAvisoSecundario,
            DiasAviso: parseInt(this.form.DiasAviso),
            DiasFinTramite: parseInt(this.form.DiasAvisoFinTramite),
            ConfigSMTP: this.form.tipo !== 3
              ? {
                Activo: this.form.smtpMain,
                Servidor: this.form.smtpServer,
                UsrDefecto: this.form.smtpFrom,
                Puerto: this.form.smtpPort,
                SSL: this.form.smptSSL,
                OAuth2: this.form.smptOAuth2,
                Relay: this.form.smtpRelay,
                ClientId: this.form.smptOAuth2 ? this.form.smptClientId : null,
                TenantId: this.form.smptOAuth2 ? this.form.smptTenantId : null,
                Usuario: this.form.smtpUser,
                Password: this.disableEditPass ? null : this.form.smtpPass,
              }
              : null,
          }
          const response = await updateGroup(params)
          if (response.blnError === false) {
            if (this.form.tipo !== 3) {
              if ((this.hasModuleCustomSMTPCliente || this.hasModuleCustomSMTPZerocoma) && this.form.smtpMain) {
                this.toggleShowHidePass(!this.form.smtpRelay)
              }
            }
            this.setAvailabityVerTodo()
            this.disableRoutes()
            this.showTestHotFolder = true
            this.doFeedback('Datos guardados correctamente', 'success')
            this.updateView()
            this.$store.commit('setAjaxRequestPending', false)
            this.resetControlFormChanges()
            if (test) {
              this.toggleModalHotFolder()
            }
          } else {
            this.doFeedback(response.msgError + ' [Código de error: ' + response.codError + ']')
          }
        } else {
          this.doFeedback('Error al procesar los datos, revise la información')
        }
        this.$store.commit('setIsLoading', false)
      })
    },
    editSmtpPassToggle () {
      if (this.disableEditPass) this.form.smtpPass = ''
      else this.form.smtpPass = '**********'
      this.disableEditPass = !this.disableEditPass
    },
    setDataSmtp: function (data) {
      if (data) {
        this.form.smtpMain = data.Activo
        this.form.smtpServer = data.Servidor
        this.form.smtpFrom = data.UsrDefecto
        this.form.smtpPort = data.Puerto
        this.form.smptSSL = data.SSL
        this.form.smptClientId = data.ClientId
        this.form.smptTenantId = data.TenantId
        this.form.smtpUser = data.Usuario
        this.form.smtpPass = '**********'
        this.form.smptOAuth2 = !(!data.ClientId && !data.TenantId)
        this.form.smtpRelay = data.Relay
        this.toggleShowHidePass(!this.form.smtpRelay)
        this.visibleEditPass = true
        this.disableEditPass = true
        this.showTestHotFolder = true
      } else {
        this.form.smtpMain = false
        this.visibleEditPass = false
        this.disableEditPass = false
      }
    },
    toggleShowHidePass (disable = true) {
      this.form.smtpPass = disable ? '**********' : ''
      this.disableEditPass = disable
      this.visibleEditPass = disable
    },
    disableRoutes: function () {
      const objDisableRoutes = {
        disableUsers: this.form.tipo === 3,
        disableStatuses: this.form.tipo === 1 || this.form.tipo === 3 || this.form.verTodoStatuses,
        disableCompanies: this.form.tipo === 1 || this.form.tipo === 3 || this.form.verTodoCompanies,
        disableGroups: this.form.verTodoAsignarGrupos,
      }
      bus.$emit('disableOptionsGroup', objDisableRoutes)
    },
    goBack: function () {
      this.$router.push({ name: 'configurations/groups' })
    },
    downloadData: async function (id) {
      let grupo = null
      try {
        this.$store.commit('setIsLoading', true)
        const params = {
          idGrupo: id
        }
        grupo = await getGroup(params)
        this.setGroup(grupo.Respuesta)
        this.disableRoutes(grupo.Respuesta)
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
      return grupo
    },
    setTemplate (group) {
      this.form.clienteId = null
      this.form.name = ''
      this.form.tipo = 2
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas
      this.form.Descripcion = ''

      this.form.EmailAvisoNueva = group.EmailAvisoNueva ? group.EmailAvisoNueva : null
      this.form.EmailAvisoDescargada = group.EmailAvisoDescargada ? group.EmailAvisoDescargada : null
      this.form.EmailAvisoTramitada = group.EmailAvisoTramitada ? group.EmailAvisoTramitada : null
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones ? group.EmailAvisoVinculaciones : null
      this.form.EmailAvisoPrincipal = group.EmailAvisoPrincipal ? group.EmailAvisoPrincipal : null
      this.form.EmailAvisoSecundario = group.EmailAvisoSecundario ? group.EmailAvisoSecundario : null
      this.form.EmailAvisoUltimaLlamada = group.EmailDiasAviso ? group.EmailDiasAviso : null
      this.form.EmailAvisoTramitacionUrgente = group.EmailAvisoTramitacionUrgente ? group.EmailAvisoTramitacionUrgente : null
      this.form.EmailAvisoErrores = group.EmailAvisoErrores ? group.EmailAvisoErrores : null
      this.form.AgruparEmailsAvisos = group.AgruparEmailsAvisos ? group.AgruparEmailsAvisos : false
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EnviarAvisoUsuariosEmailAvisoNueva = group.EnviarAvisoUsuariosEmailAvisoNueva
      this.form.EnviarAvisoUsuariosEmailAvisoDescargada = group.EnviarAvisoUsuariosEmailAvisoDescargada
      this.form.EnviarAvisoUsuariosEmailAvisoTramitada = group.EnviarAvisoUsuariosEmailAvisoTramitada
      this.form.EnviarAvisoUsuariosEmailAvisoDiasAviso = group.EnviarAvisoUsuariosEmailDiasAviso
      this.form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente = group.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente
      this.form.EnviarAvisoUsuariosEmailAvisoErrores = group.EnviarAvisoUsuariosEmailAvisoErrores
      this.form.EnviarAvisoUsuariosEmailAvisoVinculaciones = group.EnviarAvisoUsuariosEmailAvisoVinculaciones
      this.form.EnviarAvisoUsuariosEmailAvisoPrincipal = group.EnviarAvisoUsuariosEmailAvisoPrincipal
      this.form.EnviarAvisoUsuariosEmailAvisoSecundario = group.EnviarAvisoUsuariosEmailAvisoSecundario
      this.form.DiasAviso = group.DiasAviso !== null || group.DiasAviso !== undefined ? group.DiasAviso : null
      this.form.DiasAvisoFinTramite = group.DiasFinTramite !== null || group.DiasFinTramite !== undefined ? group.DiasFinTramite : null

      this.template.verTodoGroups = group.VerTodoGrupos
      this.template.verTodoStatuses = group.VerTodoEstados
      this.template.verTodoCompanies = group.VerTodoEmpresas
      this.resetControlFormChanges()
    },
    // Controla cuando puedo cambiar Ver todos los estados y Ver todas las empresas para Grupos GestorNEOs
    setAvailabityVerTodo () {
      if (this.form.tipo === 1) {
        this.availableUpdateVerTodoStatuses = this.form.verTodoStatuses === false
        this.availableUpdateVerTodoCompanies = this.form.verTodoCompanies === false
      }
    },
    setGroup: function (group) {
      this.form.id = group.IdGrupo
      this.form.name = group.Nombre
      this.form.email = group.Emails
      this.form.tipo = group.idTipoGrupo
      this.form.EnUso = group.EnUso
      this.form.clienteId = group.idEmpresa
      this.form.verTodoGroups = group.VerTodoGrupos
      this.form.verTodoAsignarGrupos = group.VerTodoAsignarGrupos
      this.form.Descripcion = group.Descripcion
      this.form.verTodoStatuses = group.VerTodoEstados
      this.form.verTodoCompanies = group.VerTodoEmpresas

      this.form.EmailAvisoNueva = group.EmailAvisoNueva ? group.EmailAvisoNueva : null
      this.form.EmailAvisoDescargada = group.EmailAvisoDescargada ? group.EmailAvisoDescargada : null
      this.form.SMSAvisoDescargada = group.NumeroSMSDescargadas ? group.NumeroSMSDescargadas.substring(4) : null
      this.form.EmailAvisoTramitada = group.EmailAvisoTramitada ? group.EmailAvisoTramitada : null
      this.form.EmailAvisoVinculaciones = group.EmailAvisoVinculaciones ? group.EmailAvisoVinculaciones : null
      this.form.EmailAvisoPrincipal = group.EmailAvisoPrincipal ? group.EmailAvisoPrincipal : null
      this.form.EmailAvisoSecundario = group.EmailAvisoSecundario ? group.EmailAvisoSecundario : null
      this.form.EmailAvisoUltimaLlamada = group.EmailDiasAviso ? group.EmailDiasAviso : null
      this.form.EmailAvisoTramitacionUrgente = group.EmailAvisoTramitacionUrgente ? group.EmailAvisoTramitacionUrgente : null
      this.form.EmailAvisoErrores = group.EmailAvisoErrores ? group.EmailAvisoErrores : null
      this.form.AgruparEmailsAvisos = group.AgruparEmailsAvisos ? group.AgruparEmailsAvisos : false
      this.form.EnviarAvisos = group.EnviarAvisos
      this.form.EnviarAvisosUsuarios = group.EnviarAvisosUsuarios
      this.form.EnviarAvisoUsuariosEmailAvisoNueva = group.EnviarAvisoUsuariosEmailAvisoNueva
      this.form.EnviarAvisoUsuariosEmailAvisoDescargada = group.EnviarAvisoUsuariosEmailAvisoDescargada
      this.form.EnviarAvisoUsuariosEmailAvisoTramitada = group.EnviarAvisoUsuariosEmailAvisoTramitada
      this.form.EnviarAvisoUsuariosEmailAvisoDiasAviso = group.EnviarAvisoUsuariosEmailDiasAviso
      this.form.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente = group.EnviarAvisoUsuariosEmailAvisoTramitacionUrgente
      this.form.EnviarAvisoUsuariosEmailAvisoErrores = group.EnviarAvisoUsuariosEmailAvisoErrores
      this.form.EnviarAvisoUsuariosEmailAvisoVinculaciones = group.EnviarAvisoUsuariosEmailAvisoVinculaciones
      this.form.EnviarAvisoUsuariosEmailAvisoPrincipal = group.EnviarAvisoUsuariosEmailAvisoPrincipal
      this.form.EnviarAvisoUsuariosEmailAvisoSecundario = group.EnviarAvisoUsuariosEmailAvisoSecundario
      this.form.DiasAviso = group.DiasAviso !== null || group.DiasAviso !== undefined ? group.DiasAviso : null
      this.form.DiasAvisoFinTramite = group.DiasFinTramite !== null || group.DiasFinTramite !== undefined ? group.DiasFinTramite : null
      this.downloadListwhiteEmail()

      this.setAvailabityVerTodo()
      this.disableRoutes()
      this.setDataSmtp(group.ConfigSMTP)
      this.resetControlFormChanges()
    },
    updateView: function () {
      this.header.breadcrumb[2].name = this.form.name
      this.$store.commit('app/setheaderBreadCrumb', this.form.name)
    }
  }
}
</script>

<style scoped>
.switch-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.switch-row > .el-switch {
  flex-shrink: 0;
  max-width: 100%;
  margin-left: auto;
}
.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}
.grid {
  display: grid;
  grid-gap: 10px;
}
.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}
.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}
.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}
.tip {
  grid-column: 1 / -1;
}
.pic > img {
  max-width: 100%;
  max-height: 100%;
}
</style>

<style lang="sass" scoped>
</style>
